var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal-content" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("h5", { staticClass: "modal-title" }, [_vm._v("Privacy Policy")]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPreList,
                expression: "showPreList"
              }
            ],
            staticClass: "row col-10 text-right"
          },
          [
            _c("table", { staticClass: "vert" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [
                  _c("b", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("sdl.gcrm.privacyPolicy.view.previous")) +
                        "   "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-right;" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.preListUrl,
                          expression: "preListUrl"
                        }
                      ],
                      staticClass: "form-control",
                      staticStyle: { padding: "0 0 0 10px", width: "328px" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.preListUrl = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.changeList()
                          }
                        ]
                      }
                    },
                    _vm._l(_vm.preList, function(item, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: item.url } },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(item.title) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.goPreUrl()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("sdl.board.label.inquery")))]
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-dismiss": "modal",
              "aria-label": "Close"
            },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body" }, [
        _c("div", { staticClass: "privacy-wrap" }, [
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "area-tit" }, [_vm._v("Area")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "area-list" },
              _vm._l(_vm.ppList, function(area) {
                return _c(
                  "div",
                  {
                    key: area.code,
                    staticClass: "form-radio",
                    on: {
                      change: function($event) {
                        return _vm.changeArea(area)
                      }
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedSrc,
                          expression: "selectedSrc"
                        }
                      ],
                      attrs: {
                        type: "radio",
                        id: area.code,
                        name: "radio-area"
                      },
                      domProps: {
                        value: area.description.url,
                        checked: _vm._q(_vm.selectedSrc, area.description.url)
                      },
                      on: {
                        change: function($event) {
                          _vm.selectedSrc = area.description.url
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-radio-label",
                        attrs: { for: area.code }
                      },
                      [_vm._v(_vm._s(_vm.getLabel(area)))]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right" }, [
            _c("iframe", {
              staticClass: "iframe",
              attrs: { src: _vm.iframeUrl, id: "terms", scrolling: "auto" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row col-12" }, [
          _vm._v(_vm._s(_vm.$t("sdl.gcrm.privacyPolicy.comment")) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("sdl.common.label.close")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "auto" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "33%" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "330px" } }),
      _vm._v(" "),
      _c("col", { staticStyle: { width: "9%" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e18b103", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e18b103","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popup/PolicyPopup.vue
// module id = null
// module chunks = 